import "./TheContentArchive.module.css";
import Header from "@/reusable_sections/Header";
import InsightsStrategy from "./sections/InsightsStrategy";
import NewsletterSignup from "./sections/NewsletterSignup";
import GlamVaultUniversalFooter from "@/reusable_sections/Footer";
export default function TheContentArchivePage() {
  return <div>
      <Header />
      <InsightsStrategy />
      <NewsletterSignup />
      <GlamVaultUniversalFooter />
    </div>;
}